export default __webpack_public_path__ + "static/SportingGrotesque-Bold-9a95b78438b492ad6a870970738be8e6.otf";